import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

const SESSION_STORAGE_KEY = 'mobileWarningDialog';

const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0 && /Mobi|Tablet/i.test(navigator.userAgent));
};

const MobileWarningDialog: React.FC = () => {
  const { t } = useTranslation('MobileWarningDialog');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isMobileDevice()) {
      return;
    }
    const dismissed = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (!dismissed) {
      setIsOpen(true);
    }
  }, []);

  const handleOpenBrowser = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'hidden');
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-secondary-main mx-auto w-full max-w-md space-y-4 rounded-xl py-8 px-6 shadow-2xl sm:max-w-lg sm:space-y-6 sm:py-12 sm:px-12 lg:max-w-xl">
        <div className="flex items-center justify-center">
          <img
            src="/assets/luxmed-diagnostyka-poziomo-24.svg"
            alt="LUXMED Diagnostyka"
            className="h-8 w-auto sm:h-10 lg:h-12"
          />
        </div>
        <div className="space-y-3 py-4 text-center sm:space-y-4 sm:py-6">
          <div className="space-y-3 sm:space-y-4">
            <p className="text-customblue-30 pt-0 text-lg font-medium leading-relaxed sm:text-xl lg:text-2xl">
              {t('Opening images')}
            </p>
            <p className="text-customblue-400 text-sm leading-relaxed sm:text-base">
              {t('Opening images description')}
            </p>
          </div>
        </div>
        <div className="flex justify-center pt-4 sm:pt-6">
          <Button
            variant="default"
            className="bg-customgreen-200 hover:bg-customgreen-200 border-customgreen-100 hover:border-customblue-50 w-full font-medium text-white transition-colors duration-200 sm:w-32 lg:w-36"
            onClick={handleOpenBrowser}
          >
            {t('Open in browser')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileWarningDialog;
